// S27: Error 500 - Server Error
import { Result, Button } from 'antd';
import { WarningOutlined, ReloadOutlined } from '@ant-design/icons';

export function Error500() {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '24px',
      }}
    >
      <Result
        status="500"
        icon={<WarningOutlined style={{ fontSize: '72px' }} />}
        title="Something went wrong"
        subTitle="We've logged this error. Please try again or contact support if it continues."
        extra={
          <Button
            type="primary"
            size="large"
            icon={<ReloadOutlined />}
            onClick={handleReload}
          >
            Reload App
          </Button>
        }
      />
    </div>
  );
}
